// Set Up

if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

(function(wp) {

  window.buildColorOptions({
    key: 'text-color',
    panel: 'Color',
    prop: 'themeTextColor',
    class: 'block-text-color',
    blocks: [
      // 'core/button',
      'core/heading',
      'core/quote',
    ],
    colors: window.BLOCKEDITOR_OPTIONS.controls.textColors,
  });

  window.buildColorOptions({
    key: 'text-color',
    panel: 'Color',
    prop: 'themeTextColor',
    class: 'block-text-color',
    blocks: [
      'core/button',
    ],
    colors: window.BLOCKEDITOR_OPTIONS.controls.buttonColors,
  });

  // window.buildColorOptions({
  //   key: 'accent-color',
  //   panel: 'Accent',
  //   prop: 'themeAccentColor',
  //   class: 'block-text-accent',
  //   blocks: [
  //     // 'core/button',
  //     'core/heading',
  //     'core/quote',
  //   ],
  //   colors: window.BLOCKEDITOR_OPTIONS.controls.textColors,
  // });

  window.buildColorOptions({
    key: 'base-color',
    panel: 'Color',
    prop: 'themeBackgroundColor',
    class: 'block-bg',
    blocks: [
      'core/group',
      'core/column',
      // 'acf/block-cards',
      // 'acf/block-topic',
      // 'theme/action-bar',
    ],
    colors: window.BLOCKEDITOR_OPTIONS.controls.bgColors,
  });

  // window.buildColorOptions({
  //   key: 'base-color-2',
  //   panel: 'Color',
  //   // prop: 'themeAccordionColor',
  //   prop: 'themeBackgroundColor',
  //   class: 'block-bg',
  //   blocks: [
  //     'acf/block-accordion',
  //     'acf/block-testimonial',
  //   ],
  //   colors: window.BLOCKEDITOR_OPTIONS.controls.bgColors2,
  // });

  // window.buildVisualOptions({
  //   key: 'pattern-style',
  //   panel: 'Pattern Style',
  //   prop: 'themePatternStyle',
  //   class: 'pattern-style',
  //   blocks: [
  //     // 'core/group',
  //     // 'core/column',
  //     'acf/block-poster',
  //     // 'acf/block-stripe-pattern',
  //     // 'acf/block-topic',
  //     // 'acf/block-header-image',
  //   ],
  //   values: window.BLOCKEDITOR_OPTIONS.controls.patternStyles,
  // });

})(window.wp);

}